import React from 'react';
import { Button } from '../../../ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faMousePointer, faSync, faCoffee } from '@fortawesome/free-solid-svg-icons';

interface ClusterMapControlsProps {
    mode: 'view' | 'select';
    onModeChange: (mode: 'view' | 'select') => void;
    onRefreshGrid?: () => void;
    gridLoading?: boolean;
    showShops?: boolean;
    onToggleShops?: () => void;
}

const ClusterMapControls: React.FC<ClusterMapControlsProps> = ({
    mode,
    onModeChange,
    onRefreshGrid,
    gridLoading = false,
    showShops = false,
    onToggleShops
}) => {
    return (
        <div className="flex flex-wrap gap-2 p-2 bg-paper/90 rounded-lg border border-ink/15 shadow-sm">
            <Button
                size="sm"
                variant={mode === 'view' ? 'default' : 'outline'}
                onClick={() => onModeChange('view')}
            >
                <FontAwesomeIcon icon={faLayerGroup} className="mr-1" />
                View
            </Button>
            <Button
                size="sm"
                variant={mode === 'select' ? 'default' : 'outline'}
                onClick={() => onModeChange('select')}
            >
                <FontAwesomeIcon icon={faMousePointer} className="mr-1" />
                Select cells
            </Button>
            {onToggleShops && (
                <Button
                    size="sm"
                    variant={showShops ? 'default' : 'outline'}
                    onClick={onToggleShops}
                >
                    <FontAwesomeIcon icon={faCoffee} className="mr-1" />
                    Shops
                </Button>
            )}
            {onRefreshGrid && (
                <Button
                    size="sm"
                    variant="outline"
                    onClick={onRefreshGrid}
                    disabled={gridLoading}
                >
                    <FontAwesomeIcon icon={faSync} className={gridLoading ? 'animate-spin mr-1' : 'mr-1'} />
                    Refresh grid
                </Button>
            )}
        </div>
    );
};

export default ClusterMapControls;
